export const NOTIFICATION_TYPES = {
  SEND_FRIEND: "SendFriend", // Lời mời kết bạn
  ACCEPT_FRIEND: "AcceptFriend", // Đồng ý kết bạn
  SHARE_POST: "PostShared", // Chia sẻ bài viết
  COMMENT_POST: "PostCommented", // Bình luận bài viết
  LIKE_POST: "PostLiked", // Thích bài viết
  REPLY_COMMENT: "ReplyComment",
  LIKE_COMMENT: "LikeComment",
  ALERT: "Alert",
  ACCEPT_RIDE: "AcceptRide",
};
